import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const N = '#0A2540';
const E = '#7C4DFF';
const ED = '#6030E8';

const styles = {
  nav: (scrolled) => ({
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    background: scrolled ? `rgba(10,37,64,0.97)` : 'transparent',
    backdropFilter: scrolled ? 'blur(14px)' : 'none',
    transition: 'all 0.3s ease',
    padding: scrolled ? '12px 0' : '20px 0',
    borderBottom: scrolled ? `1px solid rgba(124,77,255,0.25)` : 'none',
  }),
  inner: {
    maxWidth: 1200, margin: '0 auto', padding: '0 24px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  logo: {
    fontFamily: "'Poppins', sans-serif", fontWeight: 800,
    fontSize: '1.4rem', color: '#ffffff', letterSpacing: '-0.5px',
  },
  logoAccent: { color: E },
  link: (active) => ({
    color: active ? E : 'rgba(255,255,255,0.85)',
    fontWeight: 500, fontSize: '0.9rem', padding: '6px 12px',
    borderRadius: 6, transition: 'all 0.2s',
    borderBottom: active ? `2px solid ${E}` : '2px solid transparent',
  }),
  ctaBtn: {
    background: E, color: '#fff', border: 'none',
    padding: '8px 20px', borderRadius: 8, fontWeight: 600,
    fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s',
    fontFamily: 'inherit', textDecoration: 'none',
    display: 'inline-block',
  },
};

const navLinks = [
  { label: 'Home',       href: '/#home' },
  { label: 'About',      href: '/#about' },
  { label: 'Experience', href: '/#experience' },
  { label: 'Projects',   href: '/#projects' },
  { label: 'Blog',       href: '/blog' },
  { label: 'Contact',    href: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav style={styles.nav(scrolled)}>
      <div style={styles.inner}>
        <Link to="/" style={{ ...styles.logo, textDecoration: 'none' }}>
          Dennis<span style={styles.logoAccent}>.</span>
        </Link>

        {/* Desktop links */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map(link => (
            <a
              key={link.label}
              href={link.href}
              style={styles.link(location.pathname === link.href)}
              onMouseEnter={e => { e.target.style.color = E; }}
              onMouseLeave={e => { e.target.style.color = location.pathname === link.href ? E : 'rgba(255,255,255,0.85)'; }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="/#contact"
            style={styles.ctaBtn}
            onMouseEnter={e => { e.target.style.background = ED; }}
            onMouseLeave={e => { e.target.style.background = E; }}
          >
            Get in touch
          </a>
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: 'none', flexDirection: 'column', gap: 5,
            cursor: 'pointer', background: 'none', border: 'none', padding: 4,
          }}
          className="hamburger-btn"
          aria-label="Toggle menu"
        >
          <span style={{ width: 24, height: 2, background: '#fff', borderRadius: 2, display: 'block' }} />
          <span style={{ width: 24, height: 2, background: '#fff', borderRadius: 2, display: 'block' }} />
          <span style={{ width: 24, height: 2, background: '#fff', borderRadius: 2, display: 'block' }} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{
          background: `rgba(10,37,64,0.98)`, padding: '12px 24px',
          display: 'flex', flexDirection: 'column', gap: 4,
          borderTop: `1px solid rgba(124,77,255,0.15)`,
        }}>
          {navLinks.map(link => (
            <a key={link.label} href={link.href}
              onClick={() => setMenuOpen(false)}
              style={{ color: 'rgba(255,255,255,0.85)', padding: '10px 0', fontSize: '1rem', fontWeight: 500, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              {link.label}
            </a>
          ))}
          <a href="/#contact" onClick={() => setMenuOpen(false)}
            style={{ background: E, color: '#fff', padding: '10px 16px', borderRadius: 8, fontWeight: 700, marginTop: 8, textAlign: 'center' }}>
            Get in touch
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .hamburger-btn { display: flex !important; }
          nav > div:first-child > div:last-child > a,
          nav > div:first-child > div:last-child > .hamburger-btn { display: none; }
          nav > div:first-child > div:last-child { display: contents; }
        }
      `}</style>
    </nav>
  );
}
